import request from "../../../base/request";
import {message} from "antd";

let host = "/newmedia-business-server/";

const Apis = {
    // 平台维护
    getAllNewMediaType: host + "newMediaType/getAllNewMediaType",
    getNewMediaTypeById: host + "newMediaType/getNewMediaTypeById",
    createNewMediaType: host + "newMediaType/createNewMediaType",
    editNewMediaType: host + "newMediaType/editNewMediaType",
    deleteNewMediaType: host + "newMediaType/deleteNewMediaType",
    // 平台字段
    getNewMediaFields: host + "newMediaType/getNewMediaFields",
    deleteNewMediaField: host + "newMediaType/deleteNewMediaField",//添加维护字段
    saveAllNewMediaFields: host + "newMediaType/saveAllNewMediaFields", // 统一保存数据
    batchDeleteNewMediaField: host + "newMediaType/batchDeleteNewMediaField",
    recoverToDefault: host + "newMediaType/recoverToDefault",
    preDeleteNewMediaField: host + "newMediaType/preDeleteNewMediaField",
    preEditNewMediaField: host + "newMediaType/preEditNewMediaField"
};

// 平台维护接口

/**
 * 获取所有平台
 * @param body {}
 * @param callBack
 */
export const getAllNewMediaType = (body, callBack) => {
    request({url: Apis.getAllNewMediaType, body, callBack});
};


/**
 * 根据id获取平台
 * @param body
 * @param callBack {id}
 */
export const getNewMediaTypeById = (body, callBack) => {
    request({url: Apis.getNewMediaTypeById, body, callBack});
};

/**
 * 创建平台
 * @param body {}
 * @param callBack
 */
export const createNewMediaType = (body, callBack) => {
    request({
        url: Apis.createNewMediaType,
        body,
        method: "post",
        contentType: "json",
        callBack
    });
};

/**
 * 编辑平台
 * @param body
 * @param callBack
 */
export const editNewMediaType = (body, callBack) => {
    request({
        url: Apis.editNewMediaType,
        body,
        method: "post",
        contentType: "json",
        callBack
    });
};

/**
 * 删除平台
 * @param body {{id}}
 * @param callBack
 */
export const deleteNewMediaType = (body, callBack) => {
    request({
        url: Apis.deleteNewMediaType,
        body,
        callBack,
    });
};

// 维护字段接口

/**
 * 根据平台id  获取维护字段接口
 * @param body {newMediaTypeId:平台id必填}
 * @param callBack
 */
export const getNewMediaFields = (body, callBack) => {
    request({url: Apis.getNewMediaFields, body, callBack});
};

/**
 * 删除平台字段
 * @param body {newMediaFieldDefineId,newMediaTypeId}
 * @param callBack
 */
export const deleteNewMediaField = (body, callBack) => {
    request({url: Apis.deleteNewMediaField, body, callBack});
};

/**
 * 统一保存 新增接口
 * @param body newMediaFieldDefinesList newMediaTypeId
 * @param callBack
 */
export const saveAllNewMediaFields = (body, callBack) => {
    request({
        url: Apis.saveAllNewMediaFields + "?newMediaTypeId=" + body.newMediaTypeId,
        body: body.newMediaFieldDefines,
        method: "post",
        contentType: "json",
        callBack
    });
};

/**
 * 批量删除
 * @param body {{newMediaFieldDefineIds,newMediaTypeId}}
 * @param callBack
 */
export const batchDeleteNewMediaField = (body, callBack) => {
    request({
        url: Apis.batchDeleteNewMediaField,
        body: body,
        callBack
    });
};

/**
 * 恢复默认
 * @param body {{newMediaTypeId}}
 * @param callBack
 */
export const recoverToDefault = (body, callBack) => {
    request({
        url: Apis.recoverToDefault,
        body: body,
        callBack
    });
};


/**
 *
 * @param body {{newMediaFieldDefineId,newMediaTypeId}}
 * @param callBack
 */
export const preDeleteNewMediaField = (body, callBack) =>{
    request({
        url: Apis.preDeleteNewMediaField,
        body:body,
        callBack:callBack
    });
};

export function preEditNewMediaField(body, callBack) {
    request({
        url: Apis.preEditNewMediaField,
        body,
        method: "POST",
        contentType: "json",
        callBack
    });
};